import {format} from 'date-fns'

const JobApplicationEmail = async (data,values) => {
        const date_today = format(new Date(), "MM/dd/yyyy");
        const time_today = format(new Date(),'p')
        let recipients = [values.email];
        await fetch("/api/sendgrid", {
            body: JSON.stringify({
                email: recipients,
                // email:data?.email,
                from: "noreply@pmha.org.ph",
                subject: `Job Application - ${date_today}-${time_today}`,
                // message: message.props.initialValue[0].children[0].text,
                html:`
                <!DOCTYPE html>
                <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
                  xmlns:o="urn:schemas-microsoft-com:office:office">
                
                <head>
                  <title>Job Application</title>
                  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
                  <meta name="viewport" content="width=device-width, initial-scale=1" />
                  <style type="text/css">
                    #outlook a {
                      padding: 0;
                    }
                
                    body {
                      font-weight: 400;
                      margin: 0;
                      padding: 0;
                      -webkit-text-size-adjust: 100%;
                      -ms-text-size-adjust: 100%;
                    }
                
                    table,
                    td {
                      border-collapse: collapse;
                      mso-table-lspace: 0pt;
                      mso-table-rspace: 0pt;
                    }
                
                    img {
                      border: 0;
                      height: auto;
                      line-height: 100%;
                      outline: none;
                      text-decoration: none;
                      -ms-interpolation-mode: bicubic;
                    }
                
                    p {
                      display: block;
                      margin: 13px 0;
                    }
                  </style>
                
                  <link rel="preconnect" href="https://fonts.googleapis.com">
                  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet">
                
                  <style type="text/css">
                    @import url(https://fonts.googleapis.com/css?family=Inter:400,600,700);
                  </style>
                
                  <style type="text/css">
                    @media only screen and (min-width: 480px) {
                      .mj-column-per-100 {
                        width: 100% !important;
                        max-width: 100%;
                      }
                
                      .mj-column-per-35 {
                        width: 35% !important;
                        max-width: 35%;
                      }
                
                      .mj-column-per-65 {
                        width: 65% !important;
                        max-width: 65%;
                      }
                    }
                  </style>
                  <style media="screen and (min-width:480px)">
                    .moz-text-html .mj-column-per-100 {
                      width: 100% !important;
                      max-width: 100%;
                    }
                
                    .moz-text-html .mj-column-per-35 {
                      width: 35% !important;
                      max-width: 35%;
                    }
                
                    .moz-text-html .mj-column-per-65 {
                      width: 65% !important;
                      max-width: 65%;
                    }
                  </style>
                  <style type="text/css">
                    @media only screen and (max-width: 480px) {
                      table.mj-full-width-mobile {
                        width: 100% !important;
                      }
                
                      td.mj-full-width-mobile {
                        width: auto !important;
                      }
                
                      .site-logo,
                      .site-name {
                        display: block;
                        width: 100%;
                      }
                
                      .site-logo {
                        padding-bottom: 15px;
                      }
                
                      .site-name>div {
                        padding-left: 0 !important;
                      }
                    }
                  </style>
                </head>
                
                <body style="word-spacing: normal; background-color: #f1f1f1; padding-top: 10px">
                  <div style="background-color: #f1f1f1; padding-left: 20px; padding-right: 20px">
                    <div style="margin: 30px auto; background-color: #ffffff; max-width: 600px">
                      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%; background: #193e8c">
                        <tbody>
                          <tr>
                            <td style="direction: ltr; text-align: center">
                              <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;
                                  ">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle" width="100%">
                                  <tbody>
                                    <tr>
                                      <td align="" style="padding: 20px 25px; word-break: break-word">
                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: collapse; border-spacing: 0px; margin: auto;">
                                          <tbody>
                                            <tr>
                                              <td class="site-logo" style="">
                                                <img alt="OnePage" height="auto" src="https://ucarecdn.com/b68fe996-fcc1-479c-ad51-778f8f283205/pmhawhitebgapplogo.png" style="border: 0; display: block; outline: none; text-decoration: none; height: auto; width: 100%; max-width: 80px; margin: auto;" />
                                              </td>
                                              <td class="site-name" style="">
                                                <div style="font-family: 'Inter', sans-serif; font-size: 18px; font-weight: 700; line-height: 26px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #ffffff; padding-left: 20px; max-width: 300px; margin: auto;">Philippine Mental Health Association Inc.</div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%">
                        <tbody>
                          <tr>
                            <td style="direction: ltr; padding: 0; text-align: center">
                              <div class="mj-column-per-100 mj-outlook-group-fix" style=" text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle" width="100%">
                                  <tbody>
                                    <tr>
                                      <td align="center" style="padding: 30px 25px 0; word-break: break-word">
                                        <div style="font-family: 'Inter', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #193e8c;">Job Application</div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%; max-width: 550px">
                                  <tbody>
                                    <tr>
                                      <td style="direction: ltr; padding: 30px 20px 20px; text-align: center;">
                                        <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;">
                                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td align="center" style="padding: 10px 0; word-break: break-word;">
                                                  <div style="font-family: 'Inter', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000;">
                                                    Hi <strong>${values?.sex == "Male" ? "Mr. " : values?.sex == "Female" ? "Ms. " : "Mr./Ms. "} ${values.first_name}!</strong>
                                                  </div>
                                                  <div style="font-family: 'Inter', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">
                                                    Thank you for applying to the <strong> ${data?.title} </strong> position at PMHA.
                                                    <p>We would like to inform you that we received your application. Our hiring team is
                                                      currently reviewing all applications and we are planning to schedule interviews
                                                      very soon. If you are among the qualified candidates, you will receive a call or
                                                      email from us. In any case, we will keep you posted on the status of your
                                                      application.</p>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td align="center" style="font-size: 0px; padding: 10px 0 60px; word-break: break-word;">
                                                  <div style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 400; line-height: 1; text-align: left; color: #000000;">Thank you and good luck on your application!</div>
                                                </td>
                                              </tr>
                
                                              <!-- EMAIL NOTIFICATION FOOTER -->
                                              <tr>
                                                <td align="center" style="font-size: 0px; padding-top: 15px; word-break: break-word; border-top: 1px solid #eee;">
                                                  <div style="font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">
                                                    <ul style="list-style: none; padding-left: 0; text-align: center; margin-top: 0; margin-bottom: 5px;">
                                                      <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                        <a href="https://www.facebook.com/PMHAofficial" target="_blank">
                                                          <img style="width: 14px;" src="https://ucarecdn.com/0869ab43-f54d-4f83-8781-8fed79d7938b/" alt="Facebook">
                                                        </a>
                                                      </li>
                                                      <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                        <a href="https://twitter.com/PMHAofficial" target="_blank">
                                                          <img style="width: 14px;" src="https://ucarecdn.com/f8e6e9fd-7f11-4515-b088-e5567a9915ba/" alt="Twitter">
                                                        </a>
                                                      </li>
                                                      <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                        <a href="https://www.instagram.com/pmhaofficial/" target="_blank">
                                                          <img style="width: 14px;" src="https://ucarecdn.com/6b306f1a-796f-404f-86ba-400a0f766e83/" alt="Instagram">
                                                        </a>
                                                      </li>
                                                      <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                        <a href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w" target="_blank">
                                                          <img style="width: 14px;" src="https://ucarecdn.com/a822e322-e351-4d21-8bf7-14ac85a19f28/" alt="Youtube">
                                                        </a>
                                                      </li>
                                                      <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                        <a href="https://www.tiktok.com/@pmhaofficial" target="_blank">
                                                          <img style="width: 14px;" src="https://ucarecdn.com/2ed79507-7d8e-499c-afe6-85b2988aeea9/" alt="TikTok">
                                                        </a>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                  <div style="font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 400; line-height: 22px; text-align: center; color: #000000; letter-spacing: 2px;">PMHA © ${new Date().getFullYear()}</div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </body>
                
                </html>                
                `,
            }),
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
        }).then((res) =>  {
            console.log(res)
            return null
        }).catch((err) => {
            console.log(err)
            return err
        })
        recipients = [];
}

export  {JobApplicationEmail}